/*!
 * All material copyright ESRI, All Rights Reserved, unless otherwise specified.
 * See https://github.com/Esri/calcite-components/blob/master/LICENSE.md for details.
 */
export { setAssetPath, setPlatformOptions } from '@stencil/core/internal/client';
